(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const pcMenuCloseDuration = 435;

  const syncPcHeaderHeight = () => {
    const header = document.querySelector('.section-header');
    if (!header) return;

    const headerRect = header.getBoundingClientRect();
    const headerWrapper = header.querySelector('.header-wrapper');
    const ribbonHeight = headerWrapper
      ? Number.parseFloat(getComputedStyle(headerWrapper, '::after').height) || 0
      : 0;
    document.documentElement.style.setProperty('--header-height', `${headerRect.height}px`);

    header.querySelectorAll('.predictive-search--header').forEach((results) => {
      const search = results.closest('predictive-search');
      if (!search) return;

      const searchRect = search.getBoundingClientRect();
      const field = search.querySelector('.field');
      const fieldBottom = field
        ? field.getBoundingClientRect().bottom
        : headerRect.bottom - ribbonHeight;
      results.style.top = `${Math.max(0, fieldBottom - searchRect.top + 10)}px`;
    });
  };

  document.querySelectorAll('.header__icon--search').forEach((control) => {
    control.addEventListener('click', () => {
      requestAnimationFrame(syncPcHeaderHeight);
      window.setTimeout(syncPcHeaderHeight, 250);
    });
  });

  document.querySelectorAll('.header__search').forEach((search) => {
    search.addEventListener('animationend', syncPcHeaderHeight);
    search.addEventListener('input', () => requestAnimationFrame(syncPcHeaderHeight));
  });

  window.addEventListener('load', syncPcHeaderHeight);
  window.addEventListener('resize', syncPcHeaderHeight);

  const pcHeader = document.querySelector('.section-header');
  if (pcHeader && 'ResizeObserver' in window) {
    new ResizeObserver(syncPcHeaderHeight).observe(pcHeader);
  }

  syncPcHeaderHeight();

  const closePcSiteMenu = (menu) => {
    if (!menu?.open || menu.classList.contains('is-closing')) return;

    const panel = menu.querySelector('.pc-site-menu__panel');
    menu.classList.add('is-closing');

    if (panel) {
      panel.style.transition = '';
      panel.style.transform = 'translateX(-100%)';
    }

    window.setTimeout(() => {
      menu.removeAttribute('open');
      menu.classList.remove('is-closing');

      if (panel) panel.style.transform = 'translateX(-100%)';
    }, pcMenuCloseDuration);
  };

  document.querySelectorAll('.pc-site-menu').forEach((menu) => {
    const panel = menu.querySelector('.pc-site-menu__panel');
    const toggle = menu.querySelector('.pc-site-menu__toggle');
    if (!panel) return;

    toggle?.addEventListener('click', (event) => {
      event.preventDefault();
      syncPcHeaderHeight();

      if (menu.open) {
        closePcSiteMenu(menu);
        return;
      }

      menu.classList.remove('is-closing');
      menu.setAttribute('open', '');
    });

    menu.addEventListener('toggle', () => {
      if (!menu.open) {
        panel.style.transform = 'translateX(-100%)';
        return;
      }

      if (menu.classList.contains('is-closing')) return;

      panel.style.transition = 'none';
      panel.style.transform = 'translateX(-100%)';
      panel.getBoundingClientRect();

      requestAnimationFrame(() => {
        panel.style.transition = '';
        requestAnimationFrame(() => {
          panel.style.transform = 'translateX(0)';
        });
      });
    });
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.pc-site-menu[open]').forEach((menu) => {
      const panel = menu.querySelector('.pc-site-menu__panel');
      const toggle = menu.querySelector('.pc-site-menu__toggle');

      if (panel?.contains(event.target) || toggle?.contains(event.target)) return;

      closePcSiteMenu(menu);
    });
  });

  document.querySelectorAll('[data-pc-menu-close]').forEach((control) => {
    control.addEventListener('click', (event) => {
      event.stopPropagation();
      closePcSiteMenu(control.closest('.pc-site-menu'));
    });
  });

  const pcAccountMenuCloseDuration = 220;

  const closePcAccountMenu = (menu) => {
    if (!menu?.open || menu.classList.contains('is-closing')) return;

    const panel = menu.querySelector('.pc-account-menu__panel');
    menu.classList.add('is-closing');
    if (panel) {
      panel.style.opacity = '0';
      panel.style.transform = 'translateY(-6px)';
    }

    window.setTimeout(() => {
      menu.removeAttribute('open');
      menu.classList.remove('is-closing');
      if (panel) {
        panel.style.opacity = '';
        panel.style.transform = '';
      }
    }, pcAccountMenuCloseDuration);
  };

  document.querySelectorAll('.pc-account-menu').forEach((menu) => {
    const toggle = menu.querySelector('summary');
    const panel = menu.querySelector('.pc-account-menu__panel');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', (event) => {
      event.preventDefault();

      if (menu.open) {
        closePcAccountMenu(menu);
        return;
      }

      menu.classList.remove('is-closing');
      menu.setAttribute('open', '');
      panel.style.transition = 'none';
      panel.style.opacity = '0';
      panel.style.transform = 'translateY(-6px)';
      panel.getBoundingClientRect();

      requestAnimationFrame(() => {
        panel.style.transition = '';
        requestAnimationFrame(() => {
          panel.style.opacity = '';
          panel.style.transform = '';
        });
      });
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.pc-site-menu[open]').forEach(closePcSiteMenu);
    document.querySelectorAll('.pc-account-menu[open]').forEach(closePcAccountMenu);
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.pc-account-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) closePcAccountMenu(menu);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
